import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import type { ModalOptions } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { Router } from '@angular/router';
// import { Location } from '@angular/common';

import {
    AddressVerificationService, AuthService, FirebaseFunctionsService, IsoCountriesService,
    IsoTimezonesService, UsersService
} from '@shared/services';
import { RadioModalPage, ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TAddress, TIsoCountry, TCreateAccountInfo, TRegion, TIsoTimezone, TRole, TUser,
    TAccountCreationQuestionsAndAnswers, TCreateAccountResponseInfo, TApplicationFormViewModel
} from '@shared/models';
import { PhoneMaskDirective } from 'libs/directives/src/lib/phoneMask.directive';
const DateTimeFormats = Constants.DateTimeFormats;


@Component({
    'selector': 'app-apply2-application-form',
    'templateUrl': './apply2ApplicationForm.page.html',
    'styleUrls': ['./apply2ApplicationForm.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, PhoneMaskDirective ]
})
export class Apply2ApplicationFormPage extends ViewBasePage implements OnInit, OnDestroy {
    // private isoCountries: TIsoCountry[];
    // public isoTimezones: TIsoTimezones;
    // public timezones: TIsoTimezone[];
    // public regions: TRegion[];
    public vm: TApplicationFormViewModel = { 'user': { 'firstName': 'aa', 'lastName': 'bb', 'cellPhone': '(661) 877-8631', 
        'role': 'manager', 'email': 'deleteme201@shuttlenomix.com', 'uid': '' }, 'questionsAndAnswers': {} };
    public submitted = false;

    // private accountCreatorService: AccountCreatorService,
    constructor(injector: Injector) {
        super(injector);
    }

    public override async ngOnInit() {
        super.ngOnInit();
    }

    public override ngOnDestroy() {
        super.ngOnDestroy();
    }

    // public async onStateClick(): Promise<void> {
    //     const items = Constants.US_STATES.map(x => x.regionName);
    //     const options: any = {
    //         component: RadioModalPage,
    //         componentProps: { 'items': items, 'selectedItem': this.vm.stateName, 'title': 'Select State' },
    //         backdropDismiss: false,
    //         showBackdrop: true,
    //     };
    //     const myModal = await this.modalController.create(options);
    //     await myModal.present();
    //     const response: any = await myModal.onDidDismiss();
    //     if (response.data.okay) {
    //         const state = Constants.US_STATES.find(s => s.regionName === response.data.selectedItem);
    //         if (state) {
    //             this.vm.stateName = state.regionName;
    //             this.vm.stateCode = state.regionCode;
    //         }
    //     }
    // }

    // public async onJobTitleClick(): Promise<void> {
    //     const items = [
    //         'Service Manager',
    //         'Service Director',
    //         'Fixed Operations Director',
    //         'General Manager',
    //         'Owner/Dealer Principal',
    //         'BDC Manager',
    //         'Other'
    //     ];
    //     const options: any = {
    //         component: RadioModalPage,
    //         componentProps: { 'items': items, 'selectedItem': this.vm.jobTitle, 'title': 'Select Job Title' },
    //         backdropDismiss: false,
    //         showBackdrop: true,
    //     };
    //     const myModal = await this.modalController.create(options);
    //     await myModal.present();
    //     const response: any = await myModal.onDidDismiss();
    //     if (response.data.okay) {
    //         this.vm.jobTitle = response.data.selectedItem;
    //     }
    // }

    // public async onMonthlyTripsClick(): Promise<void> {
    //     const items = [
    //         'Under 100 trips',
    //         '100 - 300 trips',
    //         '300 - 500 trips',
    //         '500 - 1,000 trips',
    //         'Over 1,000 trips'
    //     ];
    //     const options: any = {
    //         component: RadioModalPage,
    //         componentProps: { 'items': items, 'selectedItem': this.vm.monthlyTrips, 'title': 'Estimated Monthly Shuttle Trips' },
    //         backdropDismiss: false,
    //         showBackdrop: true,
    //     };
    //     const myModal = await this.modalController.create(options);
    //     await myModal.present();
    //     const response: any = await myModal.onDidDismiss();
    //     if (response.data.okay) {
    //         this.vm.monthlyTrips = response.data.selectedItem;
    //     }
    // }

    // public async onReferralSourceClick(): Promise<void> {
    //     const items = [
    //         'Google Search',
    //         'Industry Conference/Event',
    //         'Referral from Another Dealer',
    //         'Vendor/Partner Recommendation',
    //         'Social Media',
    //         'Trade Publication/Article',
    //         'Other'
    //     ];
    //     const options: any = {
    //         component: RadioModalPage,
    //         componentProps: { 'items': items, 'selectedItem': this.vm.referralSource, 'title': 'How Did You Hear About Us?' },
    //         backdropDismiss: false,
    //         showBackdrop: true,
    //     };
    //     const myModal = await this.modalController.create(options);
    //     await myModal.present();
    //     const response: any = await myModal.onDidDismiss();
    //     if (response.data.okay) {
    //         this.vm.referralSource = response.data.selectedItem;
    //     }
    // }

    public async onNextClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        const info = this.buildCreateAccountInfo();
        this.setViewModel(info);
        this.router.navigateByUrl('apply/loginCredentials');
    }

    private buildCreateAccountInfo(): TCreateAccountInfo {
        const managerInfo: TUser = {
            'firstName': this.vm.user.firstName,
            'lastName': this.vm.user.lastName,
            'cellPhone': this.utilsService.unformatPhoneNumber(this.vm.user.cellPhone),
            'email': this.vm.user.email,
            'role': 'manager',
            'uid': ''
        };

        const questionsAndAnswers: TAccountCreationQuestionsAndAnswers = {
            'hasReliableInternet': false,
            'locatedInUnitedStates': false,
            'isServiceManager': false,
            'acceptsTrialTerms': false,
            'commitsToOnboarding': false
        };

        const info: TCreateAccountInfo = {
            // Manager Info
            'user': managerInfo,
            'questionsAndAnswers': questionsAndAnswers


            // Other Info
            // 'phonePrefixes': this.vm.phonePrefixes,
            // 'expirationDate': expires,
            // 'tags': [],
            // 'lists': [],
            // this.vm.countryName   = country.countryName;
            // this.vm.countryAbbr   = country.countryAbbr;
            // this.vm.countryCode   = country.isoCountryCode;
            // 'accountNumber': this.vm.accountNumber,
            // 'affiliateId': this.vm.affiliateId,
            // 'signupCouponCode': this.vm.couponCode,
            // dealership: undefined,
            // isoRegionCode: ''
        };

        // console.log('info = ', JSON.stringify(info));
        return info;
    }
}
